import ApiBase from 'modules/apis/apiBase';
import type { IResponseData } from 'modules/apis/Response';
import { Uuid } from 'modules/apis/utils';

export interface ApiElementProfessionalResponse {
    code: string;
    name: string;
}

export interface ApiPagedHospitalSchema {
    content?: Array<ApiHospitalSchema>;
    currentPage: number;
    pageSize: number;
    totalRows: number;
    totalPages: number;
}

export interface ApiHospitalSchema {
    uid?: Uuid;
    name: string;
    code: string;
}

export interface ApiOrganSchema {
    code: string;
    name: string;
}

class CommonService extends ApiBase {
    getProfessionals = () => {
        return this.get(`/professionals`) as Promise<
            IResponseData<Array<ApiElementProfessionalResponse>>
        >;
    };

    getListOfHospital = (params: { pageSize?: number; page?: number }) => {
        return this.get(`/hospitals`, {
            params,
        }) as Promise<IResponseData<ApiPagedHospitalSchema>>;
    };

    getListOfOrgan = () => {
        return this.get(`/organ`) as Promise<
            IResponseData<Array<ApiOrganSchema>>
        >;
    };
}

const commonService = new CommonService();

export default commonService;
